module.exports = __webpack_public_path__ + "img/精致美型--下巴gif.247b9c7c.gif";